import React, { useContext } from "react";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import UISearchInput from "../../ui/UISearchInput";
import AddEdit from "../AddEdit";
import { PSAdminContent } from "..";
import { DCASearch } from "../DCASearch";

export type FacilitiesHeaderProps = {
	addFacility: (data) => Promise<any>;
	onSearch: (val) => any;
	defaultValue?: string;
};

export const FacilitiesHeader: React.FC<FacilitiesHeaderProps> = (props: FacilitiesHeaderProps) => {
	const context: ILayoutContext = useContext(LayoutContext);

	return (
		<div className="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap mb-3">
			<h2 className="pb-0 mb-0">
				Facilities and Clinicians <DCASearch />
			</h2>
			{context.settings.isDesktopRes && (
				<div className="d-md-inline-flex">
					<UISearchInput
						noBorder={true}
						autoWidth={true}
						placeholder="Search facilities"
						onSearch={(val) => props.onSearch(val)}
						defaultValue={props.defaultValue}
						inputStyle={{ fontSize: "13px" }}
					/>
					<PSAdminContent>
						<AddEdit
							entity="facility"
							mode="Add"
							btnClassName="w-100-xs"
							onSubmit={(data) => props.addFacility(data)}
						/>
					</PSAdminContent>
				</div>
			)}
			{!context.settings.isDesktopRes && (
				<>
					<UISearchInput
						noBorder={true}
						autoWidth={true}
						placeholder="Search facilities"
						onSearch={(val) => props.onSearch(val)}
						inputStyle={{ maxWidth: "50vw", fontSize: "13px" }}
					/>
					<PSAdminContent>
						<AddEdit
							entity="facility"
							mode="Add"
							btnClassName="w-100 mt-2 mb-4 pb-2"
							onSubmit={(data) => props.addFacility(data)}
						/>
					</PSAdminContent>
				</>
			)}
		</div>
	);
};
